var _g;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgFaradayLogoNav = function SvgFaradayLogoNav(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 35,
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#0082ED",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.985 13.142H3.168l-1.239 8.716h8.678zM13.224 4.427H4.546l-1.378 8.715h8.817zM9.918 26.285H1.24L0 35h8.679z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.296 17.569H2.617L1.24 26.285h8.678zM12.536 8.854H3.857l-1.24 8.715h8.679zM18.184 0H9.505l-1.24 8.854h8.679z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27 0h-8.816l-1.24 8.854h8.678z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.224 4.427h4.409L18.184 0h-4.271zM21.903 4.427h4.408L27 0h-4.408z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.184 0H9.505l-1.24 8.854h8.679z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.633 4.427H8.816l-1.239 8.715h8.678zM27 0h-4.408l-1.378 8.854h4.408z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.903 4.427h4.408L27 0h-4.408z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.903 4.427 22.592 0h-4.408l-.551 4.427zM15.015 21.858H6.337l-1.378 8.853h8.679z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m9.918 26.285.689-4.427h-4.27l-.689 4.427z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.959 30.711h4.408l.551-4.426h-4.27zM0 35h4.27l.689-4.289H.689z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1.24 26.285-.551 4.426h4.27l.689-4.426zM16.255 13.142H7.577l-1.24 8.716h8.678z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.903 13.142h-5.648l-1.24 8.716h5.648z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.015 21.858h5.511l.688-4.289h-5.648z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m19.286 21.858.688-4.289h-4.408l-.551 4.289z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m11.296 17.569-.689 4.289h4.408l.551-4.289z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m11.985 13.142-.689 4.427h8.678l.689-4.427z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m19.974 17.569.689-4.427h-4.408l-.689 4.427z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m11.985 13.142-.689 4.427h4.27l.689-4.427zM9.918 26.285h4.409l.688-4.427h-4.408zM17.633 4.427H8.816l-1.239 8.715h8.678z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.265 8.854h8.679l.689-4.427H8.816zM5.648 26.285l.689-4.427H1.929l-.689 4.427z"
  }))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgFaradayLogoNav, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/faraday-logo-nav.8385ead1.svg";
export { ForwardRef as ReactComponent };